import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import modalVideo from '../../assets/videos/Video Examen de Conocimientos Concurso 2025 DEPGMLUZ- Mensaje Dr. Serio Osorio.mp4'
import ReactPlayer from 'react-player';

const ModalVideoCompacto = ({ toggleFunction, modalState }) => {
  const [videoReadyStatus, setVideoReadyStatus] = useState(false);

  const toggleVideoStatus = () => {
    setVideoReadyStatus(true);
    // console.log('Video status: ' + videoReadyStatus)
  }

  return (
    <Modal 
      show={modalState} 
      onHide={() => toggleFunction(false)} 
      dialogClassName='custom-xl modal-video-compacto'
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='modal-video-compacto info-container text-center'>
          <div className='video-container mb-2'>
            <div className={`video-canvas ${videoReadyStatus ? 'ready' : 'loading'}`}>
              <button
                className={`video-placeholder btn btn-secondary disabled placeholder-wave d-${videoReadyStatus ? 'none' : 'block'}`}
              ></button>
              <div className={`d-${videoReadyStatus ? 'block' : 'none'}`}>
                <ReactPlayer
                  className='video-player'
                  url={modalVideo}
                  playing={true}
                  volume={0.5}
                  controls={true}
                  loop
                  width={'100%'}
                  height={'auto'}
                  onReady={toggleVideoStatus}
                />
              </div>
            </div>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  )
}

export { ModalVideoCompacto }